
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@view/a-chat-2/pc/lista/controlador';
    import { ControladorChatActivo } from '@view/a-chat-2/pc/lista/sala/controlador';
    import { Mensaje } from '@/__env/lib/MercadoLibre/Chats/Mensajes';
    import JQuery from 'jquery';
    import menu_archivos from './sala-mensajes-menu-archivo.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            menu_archivos
        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorChatActivo;
        @Prop() public Mensaje: Mensaje;

        public Mouse: boolean = false;
        onMouse( x: boolean )
        {
            this.Mouse = x;
        }

        public Intervalo: any = null;
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
            clearInterval( this.Intervalo );
        }

        mounted()
        {
            this.Eventos.push( this.Controlador.onRecargarMensaje.subscribe( x =>
            {
                if ( x.id == this.Mensaje.Id )
                    this.RecargarMensaje( x );
            } ) );
            this.Intervalo = setInterval( () => { this.Recargar(); }, 60000 );
            document.getElementById( 'mensaje-' + this.Mensaje.Id ).addEventListener( 'mouseenter', () => this.onMouse( true ) );
            document.getElementById( 'mensaje-' + this.Mensaje.Id ).addEventListener( 'mouseleave', () => this.onMouse( false ) );
        }


        async RecargarMensaje( x: any )
        {
            await this.Mensaje.Recargar( x );
            this.Recargar();
        }

        DescagarAdjunto( x: string )
        {
            window.open( x );
        }

        public Refresh: boolean = true;
        public Recargar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

    }
